import module from 'colaborador/module.js'
import template from './template.html'

export class ColaboradorPrestamosExternosConfirmarComponent {
  idProyecto
  idColaborador
  data
  accion = ''
  texto = ''
  onClose = undefined
  finalizado = false

  constructor(ColaboradorPrestamosExternosCreditoService, ColaboradorPrestamoExterno) {
    this.ColaboradorPrestamosExternos = ColaboradorPrestamosExternosCreditoService
    this.ColaboradorPrestamoExterno = ColaboradorPrestamoExterno
  }

  $onInit() {
    if(this.accion === 'DESBLOQUEAR') {
      this.ColaboradorPrestamosExternos.delete(this.idProyecto, this.idColaborador)
        .then(() => (this.finalizado = true))
    }if(this.accion === 'ACTUALIZAR') {
      this.ColaboradorPrestamoExterno.put(this.data)
      .then(() => (this.finalizado = true))
    }else {
      this.ColaboradorPrestamosExternos.post(this.idProyecto, this.idColaborador, {credito: 0})
        .then(() => (this.finalizado = true))
    }
  }

  finalizar() {
    this.onClose()
  }
}

module.component('colaboradorPrestamosExternosConfirmar', {
  controller: ColaboradorPrestamosExternosConfirmarComponent,
  template,
  bindings: {
    idProyecto: '<',
    idColaborador: '<',
    texto: '<',
    accion: '<',
    onClose: '&',
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/colaborador/components/prestamosExternos/confirmar/component.js